import {
  Directive,
  EventEmitter,
  Output,
  Input,
  HostListener,
  ElementRef,
  Renderer2
} from '@angular/core';
import { WizRoot } from '../../components/views/wiz-root';

@Directive({
  selector: '[wizholdable]'
})
export class WizHoldableDirective {

  @HostListener('contextmenu', ['$event'])
  onContextMenu(event: Event) {
    event.preventDefault();
  }

  constructor(
      private el: ElementRef,
      private renderer: Renderer2
    ) {}

  ngOnInit(): void {
    // Sélection de texte
    this.renderer.setStyle(this.el.nativeElement, 'user-select', 'none');
    this.renderer.setStyle(this.el.nativeElement, '-webkit-user-select', 'none');

    // Menu contextuel mobile
    this.renderer.setStyle(this.el.nativeElement, '-webkit-touch-callout', 'none');

    // Autorise le scroll (IMPORTANT)
    this.renderer.setStyle(this.el.nativeElement, 'touch-action', 'pan-x pan-y');
  }


  @Input() longPressDelay = 400;

  @Output() wizTap = new EventEmitter<string>();
  @Output() wizHold = new EventEmitter<number>();
  @Output() verbose = new EventEmitter<string>();
  private timeout: any;
  private startTime = 0;
  private holding = false;

  /* ===== TOUCH ===== */

  private doVerbose(source: string): void {
    if(WizRoot.verboseMode) {
      this.verbose.emit('source:' + source+ ',' + (Date.now() - this.startTime));
    }
    
  }

  @HostListener('touchstart')
  onTouchStart() {
    if(WizRoot.isMobile()) {
      this.startTime = Date.now();
      this.holding = false;

      this.timeout = setTimeout(() => {
        this.holding = true;
        this.wizHold.emit(Date.now() - this.startTime);
      }, this.longPressDelay);

      this.doVerbose('touchstart');
    }

  }

  @HostListener('touchend')
  onTouchEnd() {
    if(WizRoot.isMobile()) {
      // console.log('touchend');
      clearTimeout(this.timeout);
      if (!this.holding) {
        this.wizTap.emit('mobile');
      }
      this.holding = false;
      this.doVerbose('touchend');
    }
  }

  @HostListener('touchcancel')
  onTouchCancel() {
    if(WizRoot.isMobile()) {
      clearTimeout(this.timeout);
      this.holding = false;
      this.doVerbose('touchcancel');
      }
  }

  /* ===== MOUSE ===== */

  @HostListener('mousedown')
  onMouseDown() {
    if(!WizRoot.isMobile()) {
      this.startTime = Date.now();
      this.holding = false;

      this.timeout = setTimeout(() => {
        this.holding = true;
        this.wizHold.emit(Date.now() - this.startTime);
      }, this.longPressDelay);
      this.doVerbose('mousedown');
    }
  }

  @HostListener('mouseup')
  onMouseUp() {
    if(!WizRoot.isMobile()) {
      clearTimeout(this.timeout);
      if (!this.holding) {
        this.wizTap.emit('desktop');
      }
      this.holding = false;
      this.doVerbose('mouseup');
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if(!WizRoot.isMobile()) {
      clearTimeout(this.timeout);
      this.holding = false;
      this.doVerbose('mouseleave');
      }
  }
}
